import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const createProjectSignature = (
    articles: ReturnType<typeof usePlacementStore.getState>['articles'],
    pois: ReturnType<typeof usePlacementStore.getState>['pois']
) =>
    JSON.stringify({
        articles,
        poiAssignments: pois.map((poi) => ({
            poiGuid: poi.poi.poiGuid,
            articles: poi.articles
        }))
    });
